import { CollectibleId_Schema } from "@/services/collectibles/collectiblesSchema";
import { WholeNumber_Schema } from "@/utilities/schema";
import { z } from "zod";

/** Ownership of a collectible by the current user. Mirrors the backend ItemStatusEnum (api.colectio.com#605). */
export enum CollectibleOwnershipStatus {
  InCollection = "inCollection",
  OnMarketplace = "onMarketplace",
  Archived = "archived",
  NotInCollection = "notInCollection",
}

/** Wire object keyed by variant name (foil for cards, "Normal" default bucket) → Map. */
const CountByVariant_Schema = z
  .record(z.string(), WholeNumber_Schema)
  .default({})
  .transform((counts) => new Map(Object.entries(counts)));

export const CollectibleOwnedCount_Schema = z.object({
  collectibleId: CollectibleId_Schema,
  // Lenient: an unknown future status must not break the whole overlay batch.
  status: z.nativeEnum(CollectibleOwnershipStatus).catch(CollectibleOwnershipStatus.NotInCollection),
  ownedCount: WholeNumber_Schema,
  ownedCountByVariant: CountByVariant_Schema,
  onMarketplace: WholeNumber_Schema.catch(0),
  onMarketplaceByVariant: CountByVariant_Schema,
});

export const CollectibleOwnedCountsResponse_Schema = z.object({
  items: z.array(CollectibleOwnedCount_Schema),
});
